import React, { useEffect, useState } from "react";
import styles from "../../styles/ArtworkPage.module.css";
import { getPhotos } from "../../lib/firebase/firestore"; 
import { Photo } from "../../types";
import { PhotoCard } from "../../components/PhotoCard"; // <-- updated

export const PhotoGallery = () => {
  const [photos, setPhotos] = useState<Photo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPhotos = async () => {
      try {
        const data = await getPhotos();
        setPhotos(data);
      } catch (error) {
        console.error("Failed to fetch photos:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPhotos();
  }, []);

  if (loading) return <div>Loading photos...</div>;
  if (photos.length === 0) return <div>No photos found.</div>;

  return (
    <div className={styles.artworkContainer}>
      <h1>Photo Gallery</h1>
      <div className={styles.artworkGrid}>
        {photos.map((photo) => (
          <PhotoCard key={photo.id} photo={photo} />
        ))}
      </div>
    </div>
  );
};
